__turbopack_context__.v({
  "container": "styles-module-scss-module__a_e-sa__container",
});
